import { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { IMAGE_URLS } from '../../config/constants';

const LazyImg = ({
  src,
  alt,
  imageBase,
  ...rest
}) => {
  const [isLoaded, setAsLoaded] = useState(false);

  return (
    <div className={cn('lazyload-container', {
      loaded: isLoaded,
    })}
    >
      <img
        className="lazyload"
        data-src={`${imageBase}/${src}`}
        alt={alt}
        onLoad={() => setAsLoaded(true)}
        {...rest}
      />
    </div>
  );
};

LazyImg.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imageBase: PropTypes.string,
};

LazyImg.defaultProps = {
  imageBase: IMAGE_URLS.DESKTOP,
};

export default LazyImg;
